export default {
  path: '/anomaly-results',
  component: () =>
    import(
      '@/components/pages/AnomalyResults/AnomalyResults.vue'
    )
}
